<template>
    <div class="bg_white">
        <van-nav-bar
        title="报考列表"
        left-text=""
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        >
        <template #right>
            <van-icon name="wap-home-o" size="20"/>
        </template>
        </van-nav-bar>
        <van-cell title="我要培训" is-link to="/signupType" />

        <van-cell-group v-for="(item,index) in list" :key="index" title="报考记录">
          <van-cell title="姓名" :value="item.realName" />
          <van-cell title="性别" :value="getSex(item.sex)"  />
          <van-cell title="证件号码" :value="item.idCardNo"  />
          <van-cell title="申请类型" :value="getApplyType(item.applyType)"  />
          <van-cell title="单位类型" :value="getWorkType(item.applyWorkType)"  />
          <van-cell title="提交时间" :value="item.cTime"  />
          <van-cell title="状态" :value="vipfilter(item.isVip)" />
          <div class="flex oplist">           
            <van-button type="info" size="mini" v-if="item.isVip!=2" @click="deletenow(item.id)">删除</van-button>
            <van-button type="info" size="mini" v-if="item.isVip!=2 && item.studentType==1" :to="'/signup?id='+item.id">编辑</van-button>
            <van-button type="info" size="mini" v-if="item.isVip!=2 && item.studentType==2" :to="'/signUpCy?id='+item.id">编辑</van-button>
            <van-button type="info" size="mini" @click="loadPDF(item.id)">下载报名表</van-button>
            <van-button type="primary" size="mini"   @click="preTestStudy(item)" style=" margin-left: 5px;">学时证明</van-button>
          </div>  
        </van-cell-group>

        <div v-show="openStudyProve">
          <div class="studyTime" id="pdfDom">
          <div class="title">培训学时证明</div>
          <div class="content1">
            <p> {{student.realName}}同志于{{timeDuration}}
              完成线上学时要求，特发此证，以此证明。</p>
            <p>培训内容：合计{{workCourseInfo.onlineTime}}学时</p>
            <div class="studyContent" v-html="htmlContent">

            </div>
          </div>
          <div class="userinfo">
            <li><label>姓名：</label><span>{{student.realName}}</span></li>
            <li><label>性别：</label><span>{{student.sex==1?'男':'女'}}</span></li>
            <li><label>身份证号：</label><span>{{student.idCardNo}}</span></li>
            <li><label>培训科目：</label><span>
              {{ getApplyType(student.applyType) }}
            </span></li>
          </div>
          <div class="face_img">
            <img v-if="student.studentPhoto != '' && student.studentPhoto != null" :src="'http://api.fzsyjxh.com/api/v1/getImage?name='+student.studentPhoto" alt="" >
          </div>
          <div class="foot-info">
            <div>
            </div>
            <div>
            </div>
          </div>
          <div class="seal">

          </div>
        </div>
        </div>

    </div>
</template>

<script>
import { getSignUpList,getDictData,deleteSignUp } from '../../api/custom';
import {listWorkinfoByStudentId,testStudyInfoByStudentId,getTimesDurantionByStudentId} from '../../api/course'
export default {
  data() {
    return {
      list:[],
      applyTypeList:[],
      workTypeList:[],
      pSrc: '',

      //学时
      openStudyProve:false,
      student:{},
      workCourseInfo:{},
      timeDuration:{},
      htmlContent:""
    }

   },
   created(){
    
   },
   mounted(){
    this.getList()
    this.getIdType()
   },
   methods: {
    vipfilter(status){
      if(status==0){
        return "审核中"
      }else if(status==1){
        return "已驳回"
      }else if(status==2){
        return "审核通过"
      }
    },
    loadPDF (id) {
      //pdf文件地址  测试可用
      // let baseurl = 'http://localhost:8081/api/v1/previewPdf?id='+id
      let baseurl = 'http://api.fzsyjxh.com/api/v1/previewPdf?id='+id
      //根据实际情况 通过相对路径找到viewer.html
      window.open(baseurl);
    },
    deletenow(id){
      console.log(id)
      deleteSignUp(id).then(res=>{
        console.log(res)
          this.getList()
      })
    },
    getIdType() {  
      //申领资格
      getDictData("sys_apply_type").then(res => {
        this.applyTypeList = res.data.list
      })
      
      //单位类型
      getDictData("sys_work_type").then(res => {
        this.workTypeList = res.data.list
      })
      
    },
    getApplyType(val){
      let  result=""
      this.applyTypeList.forEach(item=>{
        if(item.dictValue ==val){
          result= item.dictLabel  
        }
       })
       return result;

    },
    getWorkType(val){
      let  result=""
      this.workTypeList.forEach(item=>{
        if(item.dictValue ==val){
          result= item.dictLabel  
        }
       })
       return result;

    },
    getSex(val){
      if(val==1){
        return "男性"
      }else{
        return "女性"
      }
    },
    getList(){
      getSignUpList().then(res=>{
          this.list=res.data.list
      })
   },
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push("/home")
    },

    //检测是否完成必修
    preTestStudy(item){
      console.log(item)
      this.student=item
      testStudyInfoByStudentId(item.id).then(res=>{
        console.log(res)
        if (res.data.result){
          console.log(res.data)
          this.exportStudyTime(item)
        }else {
          // console.log("失败")
          this.$dialog.alert({
          message: "未完成必修课程",
          theme: 'round-button',
          confirmButtonText: '确定'
        })
        return
          
        }
      })
    },
    htmlDecode(text) {
      // 创建一个元素容器
      var tempDiv = document.createElement('div');
      // 把解码字符串赋值给元素innerHTML
      tempDiv.innerHTML = text;
      // 最后返回这个元素的innerText(ie支持)或者textContent(火狐、谷歌等支持)
      var output = tempDiv.innerText || tempDiv.textContent;
      tempDiv = null;
      return output;
    },

    //生成学时证明
    exportStudyTime(item){
      console.log("生成学时证明")
      
      
      // this.checkFile();
      listWorkinfoByStudentId(item.id).then(resp=>{
        this.workCourseInfo=resp.data.result
        this.htmlContent=this.htmlDecode(resp.data.result.contents)
      })
      getTimesDurantionByStudentId(item.id).then(res=>{
        console.log(res)
        this.timeDuration=res.data.result
      })
      this.openStudyProve=true

      this.$dialog.alert({
              message: "确定下载学时证明？",
              theme: 'round-button',
              confirmButtonText: '确定',

            }).then(()=>{
              this.openStudyProve=false
              this.getPdf('#pdfDom')
            })
    },

  }

};
</script>

<style lang="less">
.oplist{
  justify-content: flex-end;
  padding: 5px 15px;
}

.studyTime{
  width: 512px;
  height: 772px;
  /*height: 600px;*/
  background: url(../../asset/images/bag1.jpg) no-repeat ;
  background-size: contain;
  padding: 55px 55px 20px;
  position: relative;
  box-sizing: border-box;

}
.studyTime .face_img{
  position: absolute;
  right: 56px;
  bottom: 179px;
  /*width: 120px;*/
  font-size: 12px;
}
.studyTime .face_img img{
  height: 120px;
}
.studyTime .face_img p{
  width: 100%;
  text-align: center;
  line-height: 18px;
  color: #000000;
  font-size: 12px;
  font-weight: bold;
}
.studyTime .foot-info{
  position: absolute;
  bottom: 48px;
  display: flex;
  justify-content: space-between;
  width: 80%;
  font-size: 12px;
  font-weight: bold;
  color: #000000;
}
.studyTime .title{
  font-size: 18px;
  color: #1e1e1e;
  font-weight: bold;
  text-align: center;

}
.studyTime .content1{
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  position: static;
  line-height: 24px;
}
.studyTime li{
  list-style: none;
}

.seal{
  width: 100px;
  height: 100px;
  position: absolute;
  right: 80px;
  bottom: 40px;
  background: url(../../asset/images/redmiwork.png) no-repeat ;
  background-size: contain;
}
.studyContent{
  font-weight: normal;
  display: flex;
  /*justify-content: space-between;*/
  flex-direction: column;

}
.studyContent li{
  list-style: none;
  width: 100%;
  display: flex;
  line-height: 25px;
  border: 1px solid #000;
}
.studyContent li span:first-child{
  width: 8%;
  border-right: 1px solid #000;
  text-align: center;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.studyContent li span:nth-child(2){
  width: 77%;
  border-right: 1px solid #000;
  padding-left: 4px;
  text-align: left;
}
.studyContent li span:last-child{
  width: 20%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}


.studyContent li:nth-child(n+2){
  border-top: none;
}
.studyTime .userinfo{
  position: absolute;
  left: 63px;
  bottom: 179px;
  color: #000000;
}
.studyTime .userinfo li{
  font-weight: bold;
  color: #000000;
  line-height: 28px;
  font-size: 14px;
}

.fileImage {
  width: 400px;
  margin: 8px auto;
  position: relative;
/*// padding: 10px;*/
/*// height: 572px;*/
/*// border: 1px solid #ebedf0;*/
  border-radius: 6px;
  /*background: url(../../asset/images/filebg2.png) no-repeat;*/
  background-size: contain;
  height: 255px;
  overflow: hidden;
}
.fileImage span{
  font-size: 0.8em;
}
.fileImage .filePic{
  position: absolute;
  margin-top: 30px;
  margin-left: 26px;
  width: 90px;
  height: 115px;

}
.fileImage .fileNo{
  margin-left: 134px;
  position: absolute;
  margin-top: 39px;

}
.fileImage .name{
  margin-left: 134px;
  position: absolute;
  margin-top: 72px;
}
.fileImage .type1{
  margin-left: 252px;
  position: absolute;
  margin-top: 72px;
}

.fileImage .sex{
  margin-left: 134px;
  position: absolute;
  margin-top: 122px;
}
.fileImage .type2{
  margin-left: 252px;
  position: absolute;
  margin-top: 122px;
}
.fileImage  .fs1{
  margin-left: 28px;
  position: absolute;
  margin-top: 214px;
  font-size: 10px;
}
.fileImage  .fs2{
  margin-left: 147px;
  position: absolute;
  margin-top: 214px;
  font-size: 10px;
}
.fileImage .start{
  margin-left: 24px;
  position: absolute;
  margin-top: 181px;
  font-size: 10px;
}
.fileImage .duration{
  margin-left: 140px;
  position: absolute;
  margin-top: 181px;
  font-size: 10px;
}
.fileImage .manage{margin-left: 24px;
  position: absolute;
  margin-top: 211px;
  font-size: 10px;}
.fileImage div {
  color: #333;
  font-size: 12px;
}

.fileImage span {
  color: #000;
/*// font-size: 14px;*/
}
</style>

